var CheckUtils = /** @class */ (function () {
    function CheckUtils() {
    }
    CheckUtils.isEmpty = function (value) {
        if (value == null || value === undefined)
            return true;
        if (typeof value == 'string' || Array.isArray(value))
            return value.length == 0;
        else if (value instanceof Map || value instanceof Set)
            return value.size == 0;
        return false;
    };
    CheckUtils.areEmpty = function () {
        var values = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            values[_i] = arguments[_i];
        }
        if (CheckUtils.isEmpty(values))
            return true;
        for (var _a = 0, values_1 = values; _a < values_1.length; _a++) {
            var value = values_1[_a];
            if (CheckUtils.isEmpty(value))
                return true;
        }
        return false;
    };
    CheckUtils.isApp = function (platform) {
        return !(platform.is('core') || platform.is('mobileweb'));
    };
    return CheckUtils;
}());
export { CheckUtils };
//# sourceMappingURL=check-utils.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/utils/check-utils.js
// module id = 105
// module chunks = 14